<template>
    <div class="container-header" id="header">
        <div class="box-header-path">
            <div class="text-header-path">{{ $route.meta.title }}</div>
        </div>
        <button class="btn-logout" @click="userLogout()"></button>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import {logout} from "@/mixins/Auth";

export default {
    name: "PageHeader",
    mixins: [alertMixins],
    components: {},
    props: {},
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    beforeUnmount() {

    },
    unmounted() {
    },
    computed: {},
    methods: {
        userLogout() {
            this.logoutAlert({
                title: '로그아웃',
                text: '로그아웃 하시겠습니까?',
                cancelButtonText: '아니요',
                confirmButtonText: '네',
                showCancelButton: true,
                customClass: 'logout-alert',
                confirm: () => {
                    logout();
                },
                cancel: () => {
                }
            })
        },
    },
    watch: {}
};
</script>

<style lang="scss">
</style>
